var ChargeStatus;
(function (ChargeStatus) {
    ChargeStatus["Disconnected"] = "Disconnected";
    ChargeStatus["Waiting"] = "Waiting";
    ChargeStatus["Active"] = "Active"; // connected &&  charging
})(ChargeStatus || (ChargeStatus = {}));
